<template>
  <filter-template
    v-bind="$attrs"
    @submit="filter()"
    @clear="clearFilter()"
  >
    <v-container class="pa-0">
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          ma-2
        >
          <div class="headerSubtitle1">
            Filtros de clientes
          </div>
        </v-flex>
        <v-flex>
          <input-select
            v-model="payload.status"
            item-text="text"
            item-value="value"
            :items="status"
            :label="'Status'"
            :return-object="false"
            clearable
          />
        </v-flex>
        <v-flex>
          <input-text
            v-model="payload.cpfCnpj"
            label="Documento"
            :mask="documentMask"
          />
        </v-flex>
        <v-flex>
          <input-text
            v-model="payload.nomeFantasia"
            label="Nome fantasia"
          />
        </v-flex>
        <v-flex>
          <input-checkbox
            v-model="payload.somenteInadimplentes"
            label="Somente inadimplentes"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </filter-template>
</template>

<script>
import FilterMixin from 'Support/mixins/FilterMixin';
import rulesMixin from 'Support/mixins/rules-mixin';
import FilterTemplate from 'Support/components/filter-component/FilterTemplate.vue';
import InputSelect from 'Support/components/inputs/InputSelect.vue';
import InputText from 'Support/components/inputs/InputText.vue';
import InputCheckbox from 'Support/components/inputs/InputCheckbox.vue';

export default {
  name: 'CommunicationCustomerFilter',
  components: {
    FilterTemplate,
    InputSelect,
    InputText,
    InputCheckbox,
  },
  mixins: [FilterMixin, rulesMixin],
  data: vm => ({
    payload: {
      status: '',
      cpfCnpj: '',
      nomeFantasia: '',
      somenteInadimplentes: '',
    },
    status: [
      {
        value: vm.$t('app.customers.situations.enum.active'),
        text: vm.$t('app.customers.situations.active'),
      },
      {
        value: vm.$t('app.customers.situations.enum.inactive'),
        text: vm.$t('app.customers.situations.inactive'),
      },
      {
        value: vm.$t('app.customers.situations.enum.blocked'),
        text: vm.$t('app.customers.situations.blocked'),
      },
    ],
  }),
  computed: {
    isCpf() {
      return String(
        String(this.payload.cpfCnpj).replace(
          /[^0-9]+/g,
          '',
        ),
      ).length === 11;
    },
    documentMask() {
      if (this.isCpf) {
        return '###.###.###-##';
      }

      return '##.###.###/####-##';
    },
    storeFilters() {
      return this.store.payload.filtrosClientes;
    },
    store() {
      return this.communicationData;
    },
    isEdit() {
      return Number(this.$route.params.id) > 0;
    },
  },
  watch: {
    storeFilters: {
      immediate: true,
      deep: true,
      handler(filters) {
        if (filters && typeof filters === 'object' && this.isEdit) {
          Object.keys(filters)
            .forEach(
              (key) => {
                this.payload[key] = filters[key];
              },
            );
          this.filter();
        }
      },
    },
    payload: {
      immediate: true,
      deep: true,
      handler(payload) {
        if (payload && typeof payload === 'object') {
          this.store.setKeyData('filtrosClientes', payload);
        }
      },
    },
  },
  inject: {
    communicationData: {
      default() {
        return {};
      },
    },
  },
};
</script>
